// src/common/ui/dom-utils.js
// Basic DOM utility functions

/**
 * Escape HTML special characters
 * @param {string} s - String to escape
 * @returns {string} - Escaped string
 */
export function escapeHTML(s) {
  return String(s).replace(/[&<>"']/g, c => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[c]));
}

// Alias for backward compatibility
export const escHtml = escapeHTML;

/**
 * Create a table element from rows
 * @param {Array<[string, string|Node]>} rows - Array of [key, value] pairs
 * @returns {HTMLTableElement}
 */
export function elTable(rows) {
  const table = document.createElement('table');
  table.className = 'table';
  
  rows.forEach(([k, v]) => {
    const tr = document.createElement('tr');
    const th = document.createElement('th');
    th.textContent = k;
    
    const td = document.createElement('td');
    if (v instanceof Node) {
      td.append(v);
    } else {
      td.textContent = v;
    }
    
    tr.append(th, td);
    table.append(tr);
  });
  
  return table;
}

/**
 * Wrap text in a monospace div
 * @param {string} s - Text to wrap
 * @returns {HTMLDivElement}
 */
export function wrapMono(s) {
  const div = document.createElement('div');
  div.className = 'code';
  div.textContent = s;
  return div;
}

/**
 * Truncate string to specified length
 * @param {string} s - String to truncate
 * @param {number} n - Max length
 * @returns {string}
 */
export function truncate(s, n) {
  s = String(s || '');
  return s.length > n ? s.slice(0, n - 1) + '…' : s;
}

